import { Component, OnInit } from "@angular/core";
import { CAPService } from "../../core/services/cap-service";
import * as $ from "jquery";
import { PagerService } from "../../core/services/pager.service";
import { IDropdownSettings } from "ng-multiselect-dropdown";
 import { Router, ActivatedRoute } from "@angular/router";
//import { Console } from 'console';

@Component({
  selector: "app-useraccess",
  templateUrl: "./useraccess.component.html",
  styleUrls: ["./useraccess.component.css"],
})
export class UseraccessComponent implements OnInit {
  txtEid;
  dlstCountries;
  Countries = [];
  Roles = [];
  successfulData;
  UserAccess;
  grdFRoleModel: any[];
  grdRoleModel: any;
  UserList: any[];
  RoleDropdown;
  RoleData;
  RoleValues: any[];

  // pager object
  pager: any = {};
  // array of all items to be paged
  private allItems: any[];
  // paged items
  pagedItems: any[];
  //Country=MYCASService.country;
  //Role=MYCASService.Role;

  public dropDownSettings: IDropdownSettings;
  public country = "";
  public Type = "";
  //public rowsPerPage = 5;
  public LoginEnterpriseID = "";
  public Country;
  public DeviceType;
  public Role;
  dataLoader: boolean;

  constructor(
     private router: Router,
    private capservice: CAPService,
    private pagerService: PagerService
  ) {
    this.country = this.capservice.country;
    this.LoginEnterpriseID = this.capservice.enterpriseid;
    this.Country = this.capservice.country;
    this.Role = this.capservice.Role;

    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == "undefined") {
      alert("Invalid login");
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit() {
   
    this.dropDownSettings = {
      itemsShowLimit: 1,
      idField: "label_id",
      allowSearchFilter: true,
      textField: "label",
      selectAllText: "Check All",
      unSelectAllText: "UnCheck All",
      maxHeight: 100,
      searchPlaceholderText: "Search",
      clearSearchFilter: true,
      noDataAvailablePlaceholderText: "No data available",
    };
    this.successfulData = {
      Id: "",
      roleId: "",
      rserName: "",
      roleName: "",
      Country: "",
    };
    this.UserAccess = {
      userName: "",
      //grdFRoleModel:'',
      Country: "",
      DeviceType: "",
      roleName: "",
      RoleDesc: "",
    };

    this.CountryList();
    this.GetUserRoles();
    this.GetDropdownList();
    this.GetDetailsInitial("N", "N");
  }

  CountryList() {
    this.capservice.UserAcessCountryList(null, "N").subscribe((data) => {
      this.Countries = data;
    });
  }

  ShowData() {
    this.dataLoader = true;
    var Country =
      $("#dlstCountry").val() == "" ? "N" : $("#dlstCountry").val();
    var strParam = $("#txtEid").val() == "" ? "N" : $("#txtEid").val();
    $("#grdfuserName").val("");
    $("#grdFRole").val("");
    $("#grdfCountry").val("");
    if (Country == "N" && strParam == "N") {
      alert("Please enter value to search.");
      this.dataLoader = false;
    } else {
      this.capservice
        .SearchUserAccessDetails(strParam, "GetUserAccessDetails", Country)
        .subscribe((data) => {
          //  this.capservice.GetUserAccessDetails(strParam, "GetUserAccessDetails", Country).subscribe(data => {
          if (data.toString() == "Please Enter valid User EnterpriseID") {
            alert("Please enter valid enterprise Id");
            this.dataLoader = false;
          } else if (
            data.toString() ==
            "Please Enter valid User EnterpriseID and ApplicationID"
          ) {
            alert(
              "Please enter valid enterprise Id or\nPlease enter valid application Id"
            );
            this.dataLoader = false;
          } else if (data.length > 0) {
            $("#divuseraccessDetails").css("display", "block");
            this.successfulData = { accesss: data, selected: {} };
            this.allItems = data;
            // initialize to page 1
            this.setPage(1);
            this.dataLoader = false;
          } else {
            $("#divuseraccessDetails").css("display", "none");
            alert("No Records Found");
            this.dataLoader = false;
          }
        });
    }
  }

  EditAccess(data) {
    this.successfulData.selected = Object.assign({}, data);
    this.successfulData.selected.selectedRoleNames =
      this.successfulData.selected.roleName;
  }

  DeleteAccess(idx) {
    this.successfulData.selected = Object.assign({}, idx);
    //this.successfulData.selected.ID1 = (MYCASService.encryptedlogin(this.successfulData.selected.Id)).ciphertext.toString(CryptoJS.enc.Base64);
    this.successfulData.selected.CreateBy = this.LoginEnterpriseID;
    this.successfulData.selected.ID1 =
      this.successfulData.selected.Id.toString();
    //this.successfulData.selected.token = MYCASService.tokenManager();

    this.capservice
      .UpdateAdminDetails(this.successfulData.selected, "DeleteUserAccess",this.LoginEnterpriseID)
      .subscribe((data: any) => {
        alert(data);
        if (data == "Deleted Successfully") {
          this.GetDetailsInitial("N", this.country);
          this.clear();
          this.GetUserRoles();
        } else {
          this.GetDetailsInitial("N", this.country);
          this.clear();
          this.GetUserRoles();
        }
        this.clear();
        this.GetUserRoles();
      });
  }

  GetDetailsInitial(strParam, strCountry) {
    debugger;
    $("#divuseraccessDetails").css("display", "block");
    this.capservice
      .GetUserAccessDetails(strParam, "GetUserAccessDetails", strCountry)
      .subscribe((data) => {
        if (data.length > 0) {
          this.successfulData = { accesss: data, selected: {} };
          this.allItems = data;
          this.setPage(1);
          this.UserList = data;
        }
      });
  }

  UpdateAccess(idx) {
    debugger;
    this.dataLoader = true;
    var message = "";
    if ($("#grduserName").val() == "") {
      message = "Please Enter Enterprise Id";
    }
    if ($("#grdCountry").val() == "") {
      message = message + "\n" + "Please Select Country";
    }
    if (
      this.successfulData.selected.selectedRoleNames == "" ||
      this.successfulData.selected.selectedRoleNames == null ||
      this.successfulData.selected.selectedRoleNames == undefined
    ) {
      message = message + "\n" + "Please Select Role Name";
    }
    if (message != "") {
      alert(message);
      this.dataLoader = false;
    } else {
      this.successfulData.accesss[idx] = Object.assign(
        {},
        this.successfulData.selected
      );
      // this.successfulData.selected.Country = (MYCASService.encryptedlogin(this.successfulData.selected.Country)).ciphertext.toString(CryptoJS.enc.Base64);
      // this.successfulData.selected.userName = (MYCASService.encryptedlogin(this.successfulData.selected.userName)).ciphertext.toString(CryptoJS.enc.Base64);
      // this.successfulData.selected.RoleName = (MYCASService.encryptedlogin(this.successfulData.selected.selectedRoleNames)).ciphertext.toString(CryptoJS.enc.Base64);
      // this.successfulData.selected.ID1 = (MYCASService.encryptedlogin(this.successfulData.selected.Id)).ciphertext.toString(CryptoJS.enc.Base64);
      // this.successfulData.selected.RoleDesc = (MYCASService.encryptedlogin(this.successfulData.selected.Id)).ciphertext.toString(CryptoJS.enc.Base64);
      //this.successfulData.selected.CreateBy =(MYCASService.encryptedlogin(this.LoginEnterpriseID)).ciphertext.toString(CryptoJS.enc.Base64);
      this.successfulData.selected.RoleDesc =
        this.successfulData.selected.Id.toString();
      this.successfulData.selected.roleName =
        this.successfulData.selected.selectedRoleNames;
      this.successfulData.selected.CreateBy = this.LoginEnterpriseID;
      this.successfulData.selected.ID1 =
        this.successfulData.selected.Id.toString();
      //this.successfulData.selected.token = MYCASService.tokenManager();
      this.capservice
        .UserEnterpriseIdValidaton($("#grduserName").val())
        .subscribe((data: any) => {
          if (data == "Valid") {
            this.capservice.UpdateAdminDetails(this.successfulData.selected,"UpdateUserAccess",this.LoginEnterpriseID).subscribe((data: any) => {
               // alert(data);
                if (data == "Updated Successfully") {
                  //this.GetDetailsInitial('N', this.country);
                  alert(data);
                  // this.GetDetailsInitial('N','N');
                  this.clear();
                  this.GetUserRoles();
                  this.dataLoader = false;
                }
                else 
                {
                  alert(data);
                  this.dataLoader = false;
                }

                //     this.GetDetailsInitial('N', "N");
              });
          } else if (
            data == "Please Enter valid User EnterpriseID and ApplicationID"
          ) {
            alert(
              "Please enter valid enterprise Id or\nPlease enter valid application Id"
            );
            this.dataLoader = false;
          } else {
            alert(data);
            this.clear();
            this.GetUserRoles();
            this.dataLoader = false;
          }
        });
    }
  }

  AddAccess() {
    var message = "";
    if ($("#grdfuserName").val() == "") {
      message = "Please Enter Enterprise Id ";
    }
    if (this.RoleValues.length == 0) {
      message = message + "\n" + "Please Select At least one Role";
    }
    if ($("#grdfCountry").val() == "") {
      message = message + "\n" + "Please Select Country";
    }
    if ($("#grdfDeviceType").val() == "") {
      message = message + "\n" + "Please Select Device Type";
    }
    if (message != "") {
      alert(message);
    } else {
      this.UserAccess.roleName = "";
      this.UserAccess.RoleDesc = "";

      for (let i = 0; i < this.RoleValues.length; i++) {
        this.UserAccess.roleName += this.RoleValues[i].label + ",";
        this.UserAccess.RoleDesc += this.RoleValues[i].label_id + ",";
      }

      // }
      //this.UserAccess.Country = (MYCASService.encryptedlogin(this.UserAccess.Country)).ciphertext.toString(CryptoJS.enc.Base64);
      //this.UserAccess.userName = (MYCASService.encryptedlogin(this.UserAccess.userName)).ciphertext.toString(CryptoJS.enc.Base64);

      // this.UserAccess.RoleName = (MYCASService.encryptedlogin(this.UserAccess.RoleName.replace(/(^[,\s]+)|([,\s]+$)/g, ''))).ciphertext.toString(CryptoJS.enc.Base64);
      //this.UserAccess.RoleDesc = (MYCASService.encryptedlogin(this.UserAccess.RoleDesc.replace(/(^[,\s]+)|([,\s]+$)/g, ''))).ciphertext.toString(CryptoJS.enc.Base64);
      //this.UserAccess.CreateBy = (MYCASService.encryptedlogin(this.LoginEnterpriseID)).ciphertext.toString(CryptoJS.enc.Base64);
      //this.UserAccess.token = MYCASService.tokenManager();
      this.UserAccess.CreateBy = this.LoginEnterpriseID;
      this.UserAccess.roleName = this.UserAccess.roleName.replace(
        /(^[,\s]+)|([,\s]+$)/g,
        ""
      );
      this.UserAccess.RoleDesc = this.UserAccess.RoleDesc.replace(
        /(^[,\s]+)|([,\s]+$)/g,
        ""
      );
      //this.UserAccess.RoleDesc=18;
      this.capservice
        .UserEnterpriseIdValidaton($("#grdfuserName").val())
        .subscribe((data: any) => {
          if (data == "Valid") {
            this.capservice
              .UpdateAdminDetails(this.UserAccess, "InsertUserAccess",this.LoginEnterpriseID)
              .subscribe((data: any) => {
                //alert(data);
                //  this.clear();
                //  this.GetUserRoles();
                if (data == "Inserted Successfully") {
                  alert(data);
                  this.GetDetailsInitial("N", "N");
                  this.clear();
                  this.GetUserRoles();
                }
                   else {
                    //alert("Bad Request 404!");
                    alert(data);
                    this.GetDetailsInitial('N', 'N');
                    this.clear();
                    this.GetUserRoles();
                }
           });
          }
          // }
          // else if(data =="Please Enter valid User EnterpriseID and ApplicationID"){
          //   alert("Bad Request 404!");
          //   this.GetDetailsInitial('N', 'N');
          //   this.clear();
          //   this.GetUserRoles();
          // }
           else {
            alert(data);
            this.clear();
            this.GetUserRoles();
          }
        });
    }
  }

  Reset() {
    this.successfulData.selected = {};
    //  this.UserAccess.RoleName = '';
    // this.grdFRoleModel = '';
    $("#grduserName").val("");
    $("#grdRole").val("");
    $("#grdCountry").val("");

    var Country =
      $("#dlstCountry").val() == "" ? this.country : $("#dlstCountry").val();
    var strParam = $("#txtEid").val() == "" ? "N" : $("#txtEid").val();
    this.GetDetailsInitial("N", "N");
  }

  GetDropdownList() {
    var MultiDestiantionObj = { MultiDestinationArray: [] };
    this.RoleValues = [];

    this.capservice
      .GetUserAccessDetails("N", "GetUserRoles", this.Role)
      .subscribe((data) => {
        this.grdFRoleModel = data;
        for (var i = 0; i < data.length; i++) {
          var Destination = {
            label_id: data[i].roleId,
            label: data[i].roleName,
          };

          MultiDestiantionObj.MultiDestinationArray.push(Destination);
        }
        this.grdFRoleModel = MultiDestiantionObj.MultiDestinationArray;
      });
  }

  GetUserRoles() {
    this.capservice
      .GetUserAccessDetails("N", "GetUserRoles", this.Role)
      .subscribe((data) => {
        this.Roles = data;
      });
  }

  clear() {
    $("#grdfuserName").val("");
    $("#grdFRole").val("");
    $("#grdfCountry").val("");
    $("#grduserName").val("");
    $("#grdRole").val("");
    $("#grdCountry").val("");
    $("#txtEid").val("");
    $("#dlstCountry").val("");
    $("#grdFRoleModel").val("");
    this.UserAccess.DeviceType = "";
    //this.RoleValues = [];
    this.grdFRoleModel = [];
    // $('#grdFRoleModel').val('')
    this.GetDetailsInitial("N", "N");
    this.UserAccess.roleName = "";
    this.GetDropdownList();
    //this.grdFRoleModel = '';
    this.dataLoader = false;
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.accesss = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
}
